import React from "react";
import { FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
import { motion } from "framer-motion";

const CommunityPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0F20] flex flex-col items-center justify-center text-center px-4">
      {/* Heading */}
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="text-4xl sm:text-5xl font-extrabold text-white mb-4"
      >
        Welcome to the <br />
        <span className="text-blue-600 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
          AI Community
        </span>
      </motion.h1>

      {/* Subheading */}
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.6 }}
        className="text-lg sm:text-xl text-gray-400 mb-6 max-w-xl"
      >
        Connect with like-minded learners and experts to grow your skills in AI, Python, and more!
      </motion.p>

      {/* Launch Announcement */}
      <motion.p
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.4, duration: 0.4 }}
        className="text-md sm:text-lg text-gray-300 mb-8 max-w-xl"
      >
        <strong>Stay tuned!</strong> Our community will be launching soon.
        <br />
        Meanwhile, follow us on{" "}
        <span className="text-blue-600 font-medium">Twitter</span>,{" "}
        <span className="text-blue-600 font-medium">LinkedIn</span>, and{" "}
        <span className="text-blue-600 font-medium">Instagram</span>!
      </motion.p>

      {/* Social Icons */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="mt-4 flex gap-6"
      >
        <a
          href="https://x.com/PolaSaiKumar3"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-blue-600 transition-all duration-300"
        >
          <FaTwitter size={28} />
        </a>

        <a
          href="https://www.linkedin.com/in/sai-kumar-pola-3993851a1/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-blue-600 transition-all duration-300"
        >
          <FaLinkedin size={28} />
        </a>

        <a
          href="https://www.instagram.com/thisz__chinnu/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-400 hover:text-blue-600 transition-all duration-300"
        >
          <FaInstagram size={28} />
        </a>
      </motion.div>
    </div>
  );
};

export default CommunityPage;